import React, { FormEventHandler } from 'react';

/**
 * by default if no onSubmit is supplied, prevent default so that
 * we don't POST to the browser via standard form submit when ENTER is pressed
 */
const defaultOnSubmit: FormEventHandler<HTMLFormElement> = (e) => e.preventDefault();

interface FormProps {
  children: React.ReactNode;
  id?: string;
  /**
   * @default (e) => e.preventDefault();
   */
  onSubmit?: FormEventHandler<HTMLFormElement>;
  /**
   * @default true
   */
  noValidate?: boolean;
  style?: React.HTMLAttributes<HTMLFormElement>['style'];
}

// TODO - discuss strategy for submitting forms on keypress
//      - "Enter" should probably remain default (for good reason)
//        * it is the web standard
//        * better for folks leaning on accessibility tools
//        * preventing enter when not holding shift also stops non form submission events
//          for example, tabbing to a save button and clicking enter, selecting item in drop down, etc..
//      - we could have opt in, with enum prop:
//      - submitKey: 'Enter' | 'ShiftEnter' | 'None Or Disabled'
export const Form = (props: FormProps): React.ReactElement => {
  const { children, noValidate, onSubmit, ...rest } = props;
  return (
    <form noValidate={noValidate !== undefined ? noValidate : true} onSubmit={onSubmit || defaultOnSubmit} {...rest}>
      {children}
    </form>
  );
};
